import { isMasterAdmin, isSchoolAdmin } from '../../constants/roles';

// Shared per-field guard rules for editing another user's account fields
// (role/school/access) and for the destructive drawer-footer actions
// (reset password, delete) — used identically by StudentDrawer and
// StaffDrawer (via AccountSection.js) so a SCHOOL_ADMIN's exact reach
// (can touch a TEACHER or another SCHOOL_ADMIN, but never a MASTER_ADMIN
// or the legacy "admin" role) can never drift between the two drawers.
// Mirrors the server-side rule in app/dependencies.py's
// assert_not_outranked - a MASTER_ADMIN/legacy "admin" *viewer* is never
// blocked by either guard below, only SCHOOL_ADMIN is checked.

// Blocks every "act on this account" affordance a SCHOOL_ADMIN doesn't
// have server-side: touching a peer SCHOOL_ADMIN or any MASTER_ADMIN's
// access/reset-password/delete. (The "can't touch my own access" and
// "can't self-revoke as MASTER_ADMIN" rules are extra, narrower checks
// layered on top of this in AccountSection.js, not part of this guard.)
export const staffTierGuard = (currentUserRole, targetRole) =>
  isSchoolAdmin(currentUserRole) && (isMasterAdmin(targetRole) || isSchoolAdmin(targetRole));

// Narrower than staffTierGuard - only blocks the Role select specifically
// from touching a MASTER_ADMIN target. A SCHOOL_ADMIN may still change
// another SCHOOL_ADMIN's role (e.g. demote them), which staffTierGuard
// alone would incorrectly block if reused here.
export const roleEditGuard = (currentUserRole, targetRole) =>
  isSchoolAdmin(currentUserRole) && isMasterAdmin(targetRole);
